import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [filterEmail, setFilterEmail] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_PREFIX}api/orders?organisationCode=CA-CEST-POUR-MOI`, {
       // const res = await fetch(`${process.env.REACT_APP_API_PREFIX}api/orders`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const data = await res.json();
        setOrders(data);
        setFilteredOrders(data);
      } catch (err) {
        console.error('Erreur de récupération des commandes :', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [token]);

  const toggleExpand = (id) => {
    setExpandedOrderId(expandedOrderId === id ? null : id);
  };

  const resetFilters = () => {
    setFilterEmail('');
    setStartDate('');
    setEndDate('');
    setFilteredOrders(orders);
  };

  useEffect(() => {
    const handleFilter = () => {
      const filtered = orders.filter(order => {
        const matchEmail = filterEmail ? order.email?.toLowerCase().includes(filterEmail.toLowerCase()) : true;
        const orderDate = new Date(order.date);
        const matchStartDate = startDate ? orderDate >= new Date(startDate) : true;
        const matchEndDate = endDate ? orderDate <= new Date(endDate) : true;
        return matchEmail && matchStartDate && matchEndDate;
      });
      setFilteredOrders(filtered);
    };
    
    handleFilter();
  }, [filterEmail, startDate, endDate, orders]);

  const totalOrders = filteredOrders.length;
  const totalRevenue = filteredOrders.reduce((sum, order) => sum + (order.totalPrice || 0), 0);
  const averageOrder = totalOrders > 0 ? (totalRevenue / totalOrders).toFixed(2) : 0;

  const productStats = {};
  filteredOrders.forEach(order => {
    order.items?.forEach(item => {
      // Extraire le nom de base du produit (sans la date)
      const baseName = item.name.replace(/\s+jusqu'au\s+\d{2}\/\d{2}\/\d{4}/, '');
      
      if (!productStats[baseName]) {
        productStats[baseName] = { quantity: 0, total: 0 };
      }
      productStats[baseName].quantity += item.quantity;
      productStats[baseName].total += item.quantity * item.price;
    });
  });

  const topProducts = Object.entries(productStats)
    .sort(([, a], [, b]) => b.quantity - a.quantity)
    .slice(0, 10);


  if (loading) return <div>Chargement des commandes...</div>;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Commandes - CCPM</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
  <div className="bg-white border-l-4 border-blue-500 shadow p-4 rounded">
    <p className="text-sm text-gray-500">Total commandes</p>
    <p className="text-2xl font-bold text-gray-800">{totalOrders}</p>
  </div>
  <div className="bg-white border-l-4 border-green-500 shadow p-4 rounded">
    <p className="text-sm text-gray-500">Montant total</p>
    <p className="text-2xl font-bold text-gray-800">{totalRevenue.toFixed(2)} €</p>
  </div>
  <div className="bg-white border-l-4 border-purple-500 shadow p-4 rounded">
    <p className="text-sm text-gray-500">Montant moyen</p>
    <p className="text-2xl font-bold text-gray-800">{averageOrder} €</p>
  </div>
</div>

{topProducts.length > 0 && (
  <div className="bg-white shadow p-4 rounded mb-6 border border-gray-200">
    <h4 className="text-md font-semibold mb-2 text-gray-700">🥇 Top 10 produits les plus vendus</h4>
    <ul className="list-disc list-inside text-sm text-gray-600">
      {topProducts.map(([name, data]) => (
        <li key={name} className="mb-1">
          <span className="font-medium text-gray-800">{name}</span> — {data.quantity} vendu(s), {data.total.toFixed(2)} €
        </li>
      ))}
    </ul>
  </div>
)}



      <div className="mb-4 flex flex-col md:flex-row gap-4 items-center">
        <input
          type="text"
          placeholder="Filtrer par email"
          value={filterEmail}
          onChange={(e) => setFilterEmail(e.target.value)}
          className="border px-3 py-1 rounded w-full md:w-60"
        />
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="border px-3 py-1 rounded w-full md:w-48"
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="border px-3 py-1 rounded w-full md:w-48"
        />
        <button
          onClick={resetFilters}
          className="bg-gray-200 text-sm px-4 py-1 rounded hover:bg-gray-300"
        >
          Réinitialiser
        </button>
      </div>

      {filteredOrders.length === 0 ? (
        <p>Aucune commande trouvée.</p>
      ) : (
        <table className="w-full border border-gray-300 text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Numéro</th>
              <th className="p-2 border">Date</th>
              <th className="p-2 border">Nom</th>
              <th className="p-2 border">Email</th>
              <th className="p-2 border">Total</th>
              <th className="p-2 border">Statut</th>
              <th className="p-2 border">Détails</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.map(order => (
              <React.Fragment key={order.externalId}>
                <tr>
                  <td className="p-2 border">{order.number}</td>
                  <td className="p-2 border">{new Date(order.date).toLocaleDateString()}</td>
                  <td className="p-2 border">{order.firstname} {order.lastname}</td>
                  <td className="p-2 border">{order.email}</td>
                  <td className="p-2 border">{order.totalPrice} €</td>
                  <td className="p-2 border">{order.status}</td>
                  <td className="p-2 border">
                    <button
                      className="text-blue-600 underline"
                      onClick={() => toggleExpand(order.externalId)}
                    >
                      {expandedOrderId === order.externalId ? 'Masquer' : 'Voir'}
                    </button>
                  </td>
                </tr>
                {expandedOrderId === order.externalId && (
                  <tr>
                    <td colSpan="7" className="p-2 border bg-gray-50">
                      <div className="text-left text-sm">
                        <p className="mb-2 font-semibold">Méthodes de livraison :</p>
                        <ul className="mb-4 list-disc list-inside">
                          {order.deliveryMethods?.map((d, i) => (
                            <li key={i}>{d.name || d.type}</li>
                          )) || <li>Aucune</li>}
                        </ul>
                        <p className="mb-2 font-semibold">Méthodes de paiement :</p>
                        <ul className="mb-4 list-disc list-inside">
                          {order.paymentMethods?.map((p, i) => (
                            <li key={i}>{p.name || p.type}</li>
                          )) || <li>Aucune</li>}
                        </ul>
                        <p className="mb-2 font-semibold">Contenu de la commande :</p>
                        <ul className="list-disc list-inside">
                          {order.items?.map((item, i) => (
                            <li key={i}>
                              {item.name} — {item.quantity} × {item.price} €
                            </li>
                          )) || <li>Pas d’articles</li>}
                        </ul>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrdersPage;
